/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Login_LinkInputs */

const es_co2_signup_login_link = /** @type {(inputs: Signup_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión`)
};

/**

* @param {Signup_Login_LinkInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_login_link = /** @type {((inputs?: Signup_Login_LinkInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Login_LinkInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_login_link(inputs)
});